import Splide from "@splidejs/splide";

export default () => ({
  init() {
    this.initSlider();
  },

  initSlider() {
    const inBackend = document.body.classList.contains("neos-backend");

    if (inBackend) return;

    const sliders = document.querySelectorAll(".portfolio-splide");

    sliders.forEach((item) => {
      const slider = new Splide(item, {
        perPage: 5,
        start: 2,
        padding: "5rem",
        gap: "2rem",
        arrows: null,
        type: "loop",
        focus: "center",
        pagination: null,
        drag: true,
        breakpoints: {
          500: {
            perPage: 1,
            gap: "1rem",
            start: 0,
          },
          800: {
            perPage: 2,
            gap: "2rem",
            start: 1,
          },
          1000: {
            perPage: 3,
            gap: "2rem",
            start: 1,
          },
        },
      });
      slider.mount();
    });
  },
});
